import { render, staticRenderFns } from "./FormationsItem3.vue?vue&type=template&id=e45abba6&"
import script from "./FormationsItem3.vue?vue&type=script&lang=js&"
export * from "./FormationsItem3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports